module.exports = __webpack_public_path__ + "img/external-link.43654c4d.svg";